import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ApiService} from 'src/app/core/api/api.service';
import {IDropdownSettings} from 'ng-multiselect-dropdown';
import {
  FIRE_PARTITION_STATUSES,
  FIRE_PARTITION_TYPES,
  FirePartitionStatus,
  FirePartitionType,
  MATERIAL_STATUSES,
  MaterialStatus,
  sortedValues
} from "../../core/models/firepartition.type";

@Component({
    selector: 'bergh-all-materials-tab',
    templateUrl: './all-materials-tab.component.html',
    styleUrls: ['./all-materials-tab.component.scss'],
    standalone: false
})
export class AllMaterialsTabComponent implements OnInit {
  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'name',
    textField: 'nameDutch',
    itemsShowLimit: 3,
    selectAllText: 'Alle',
    unSelectAllText: 'Geen',
  };
  fpStatuses = sortedValues(FIRE_PARTITION_STATUSES)
  fpTypes = sortedValues(FIRE_PARTITION_TYPES)
  materialStatuses = sortedValues(MATERIAL_STATUSES)

  projectId: string;
  public selectedExtraWork: boolean = null;
  public selectedFpStatuses: FirePartitionStatus[] = [];
  public selectedTypes: FirePartitionType[] = [];
  public selectedMaterialStatuses: MaterialStatus[] = [];
  public materialsList = [];
  protected loading = false;

  constructor(private _api: ApiService,
              private _route: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    this.projectId = this._route.snapshot.paramMap.get('id');
    void this.getAvailableFpForMaterialTab();
  }

  public async getAvailableFpForMaterialTab() {
    if (!this.loading) {
      this.loading = true;
      this.materialsList = [];
      try {
        this.materialsList = await this._api.getAllMaterialsListProject(this.projectId, {
          isExtraWork: this.selectedExtraWork,
          typeNames: this.selectedTypes.map(type => type.name),
          statusNames: this.selectedFpStatuses.map(st => st.name),
          materialStatusNames: this.selectedMaterialStatuses.map(st => st.name),
        })
      } finally {
        this.loading = false
      }
    }
  }
}
